import React, { FC, useEffect, useState } from "react";
import { Input, Select } from "antd";
import {
	BOOL_COLUMNS,
	BOOL_DROPDOWN,
	CODE_HIERARHY,
	CODE_HIERARHY_DROPDOWN,
	COUNTRY,
	DATA_REPORTING_ESTIMATION,
	DATA_REPORTING_ESTIMATION_DROPDOWN,
	DIRECT_INDIRECT,
	DIRECT_INDIRECT_COLUMNS,
	DROPDOWN_COLUMNS,
	E_CUSTOMER_TYPE,
	EREDS_COLUMNS,
	EREDS_DROPDOWN,
	PFP_IMPLEMENTATION,
	PFP_IMPLEMENTATION_DROPDOWN,
	PRIORITY, PRIORITY_DROPDOWN,
	SELL_DATA_MESH,
	SELL_DATA_MESH_DROPDOWN,
	SELLES_DATA_SHARING,
	SELLES_DATA_SHARING_DROPDOWN
} from "./constants";
import { useSelector } from "react-redux";
import { IActiveCustomer } from "../../reducer/ECommCustomers/_interfaces";

type IProps = {
	title: string;
	editable: boolean;
	children: any;
	dataIndex: keyof IActiveCustomer;
	record: IActiveCustomer;
	handleSave: (newRecord:IActiveCustomer) => void;
	[key:string]: any;
}

const EditableCell:FC<IProps> = ({
	title,
	editable,
	children,
	dataIndex,
	record,
	handleSave,
	...restProps
}) => {
    const countries = useSelector((state:any) => state.eCommCustomers.countries);
	const subChannels = useSelector((state:any) => state.eCommCustomers.subChannels);

	const [editing, setEditing] = useState(false);
	const inputRef = React.useRef<any>(null);
	let options:any[] = [];

	const isDropdown = DROPDOWN_COLUMNS.includes(dataIndex)

	if (dataIndex === COUNTRY) options = countries;
	if (dataIndex === E_CUSTOMER_TYPE) options = subChannels;
    if (dataIndex === SELL_DATA_MESH) options = SELL_DATA_MESH_DROPDOWN;
    if (dataIndex === PRIORITY) options = PRIORITY_DROPDOWN;
    if (dataIndex === PFP_IMPLEMENTATION) options = PFP_IMPLEMENTATION_DROPDOWN;
    if (dataIndex === SELLES_DATA_SHARING) options = SELLES_DATA_SHARING_DROPDOWN;
    if (dataIndex === DIRECT_INDIRECT) options = DIRECT_INDIRECT_COLUMNS;
    if (dataIndex === CODE_HIERARHY) options = CODE_HIERARHY_DROPDOWN;
	if (dataIndex === DATA_REPORTING_ESTIMATION) options = DATA_REPORTING_ESTIMATION_DROPDOWN;
    if (BOOL_COLUMNS.includes(dataIndex)) options = BOOL_DROPDOWN;
    if (EREDS_COLUMNS.includes(dataIndex)) options = EREDS_DROPDOWN;

	useEffect(() => {
		if (editing) inputRef.current?.focus();
	}, [editing]);

	const toggleEdit = () => {
		setEditing(!editing);
	};

	const saveDropdown = async (newValue:{label:string, value:string}) => {
		handleSave({
			...record,
			[dataIndex]: newValue.value,
			status: record.status
			// ...(dataIndex === COUNTRY ? { [COUNTRY_CODE]: newValue.value } : {})
		});
	}

	const save = async (values:any) => {
		try {
			toggleEdit();
			handleSave({
				...record,
				[dataIndex]: values.target.value
			});
		} catch (errInfo) {
			console.log('Save failed:', errInfo);
		}
	};

	let childNode = children;

	const defaultValue = options.find(({value}) => value === record[dataIndex])

	if (editable) {
		childNode = editing ? (
			<>
				{isDropdown &&
					<Select
						style={{width: '100%'}}
						labelInValue
						options={options}
						onChange={saveDropdown}
						value={defaultValue}
						
					/>
				}
				{!isDropdown &&
					<Input
						defaultValue={record?.[dataIndex] as any || null}
						ref={inputRef}
						onPressEnter={save}
						onBlur={save}
						data-lpignore="true"
					/>
				}
				
			</>
		) : (
			<div
				className="editable-cell-value-wrap"
				style={{
					minHeight: 28,
					paddingInlineEnd: 24,
				}}
			>
				{isDropdown
					? options.find(({value}) => value === children[1])?.label
					: children
				}
			</div>
		);
	}
	return (
		<td {...restProps} onClick={() => setEditing(true)}>
			{childNode}
		</td>
	);
};

export default EditableCell;